import React, { useState, useEffect } from 'react';
import styles from './SearchBox.module.scss';
import { MagnifierIcon, XIcon } from '../../../Interfaces/Icons';

interface SearchBoxProps {
    placeholderText: string;
    phrase: string;
    setPhrase: (phrase: string) => void;
    triggerSearch: (phrase?: string) => void;
}

const SearchBox: React.FC<SearchBoxProps> = ({ placeholderText, phrase, setPhrase, triggerSearch }) => {
    const [query, setQuery] = useState<string>(phrase || "");
    
    // Sync query with phrase prop changes
    useEffect(() => {
        setQuery(phrase || "");
    }, [phrase]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setQuery(event.target.value);
    };

    const handleSearch = (query, phrase) => {
        if (query !== phrase) {
            setPhrase(query);
            triggerSearch(query);
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleSearch(query, phrase);
        }
    };

    const handleClearButtonClick = () => {
        setQuery("");
        setPhrase("");
        triggerSearch("");
    }

    return (
        <section id="search-box-container" className={`${styles["search-box-container"]} section`}>
                        <div className={styles["search-form-wrapper"]} data-aos="fade-up" data-aos-delay="100">
                            <div className="row gx-3">
                                <div className="col-12">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={query}
                                                placeholder={placeholderText}
                                                onChange={handleInputChange}
                                                onKeyDown={handleKeyDown}
                                            >
                                            </input>
                                            {query && (
                                                <>
                                                <button
                                                    type="button"
                                                    className="btn btn-clear"
                                                    onClick={handleClearButtonClick}>
                                                    <XIcon />
                                                </button>
                                                <span className="btn-seperator"></span>
                                                </>
                                            )}         
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() => handleSearch(query, phrase)}
                                            >
                                                <MagnifierIcon />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
        </section>
    );
};

export default SearchBox;
